module.exports = __webpack_public_path__ + "img/Trial.c252afa0.png";